import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.azalega-academy.com/api/v1',
    withCredentials: true
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// --- ADMIN FOLDER SERVICES (REAL BACKEND) ---

export async function getAllFolders() {
    // Using the same public endpoint for listing, but Admin usually needs specific stats.
    // Ideally we use GET /alerts/admin/folders if we made one, or GET /alerts/folders
    // Since getFolders returns active ones, let's assume admin sees all via a database call
    // But for now, let's use the public one which works. 
    // UPDATE: We didn't make a specific "List all for admin" endpoint in controller, 
    // but getFolders works for now.

    const res = await api.get('/alerts/folders');

    // We need alert counts. Backend getFolders doesn't return counts yet.
    // For MVP, we'll return 0 count or fetch alerts to count. 
    // Let's keep it simple.

    return res.data.data.map(f => ({
        folder_id: f._id,
        code: f.code,
        name: f.name,
        is_active: true, // Assuming active since fetched
        total_alert_count: 0, // Placeholder
        created_date: new Date().toISOString()
    }));
}

export async function createFolder(folderData) {
    const res = await api.post('/alerts/admin/folders', {
        name: folderData.name,
        code: folderData.code,
        description: folderData.description || ''
    });

    const f = res.data.data;
    return {
        success: true,
        folder_id: f._id,
        code: f.code,
        name: f.name,
        is_active: true
    };
}

export async function updateFolder(folderId, folderData) {
    const res = await api.put(`/alerts/admin/folders/${folderId}`, folderData);
    const f = res.data.data;
    return {
        success: true,
        folder_id: f._id,
        name: f.name,
        code: f.code
    };
}

export async function deleteFolder(folderId) {
    await api.delete(`/alerts/admin/folders/${folderId}`);
    return { success: true, folder_id: folderId };
}

// --- ADMIN ALERT SERVICES ---

export async function getAllAlerts(filters = {}) {
    // Admin needs to see ALL alerts, not just subscribed ones.
    // We need to implement a specific admin endpoint for this in future.
    // For now, let's try fetching with a huge limit using general endpoint 
    // (Note: This might be filtered by subscription in current backend logic, 
    // but admin role might bypass it if we coded it right. 
    // Checking controller... Yes! "if (!sub && req.user.role !== 'admin')" -> Admin passes!)

    const res = await api.get('/alerts', { params: { limit: 1000, ...filters } });

    return res.data.data.map(a => ({
        alert_id: a._id,
        folder_id: a.folder,
        signal: a.signal,
        pair: a.symbol,
        timeframe: a.timeframe,
        entry: a.entryPrice,
        tp_json: Array.isArray(a.takeProfit) ? a.takeProfit : [a.takeProfit],
        text: a.rawMessage,
        created_date: a.createdAt
    }));
}

// --- OTHER SERVICES (MOCK/PLACEHOLDER) ---

export async function verifyAdminRole() {
    return { role: 'admin' };
}

// Temporary mocks to prevent admin panel crash until fully implemented
export async function getAllTermsVersions() { return []; }
export async function createTermsVersion() { return { success: true }; }
export async function getTermsAcceptanceStats() { return {}; }
export async function getAllUsers() { return []; }
export async function getUserFolders(userId) { return { folders: [] }; }
export async function ingestAlert(data) {
    // Use the Webhook endpoint for testing ingestion
    await api.post('/alerts/webhook', data);
    return { success: true };
}
